import React from "react";
import {Github} from "react-bootstrap-icons";
import {Link} from "react-router-dom";
import {Linkedin} from "react-bootstrap-icons";
import profile from "../../assets/img/profile.png";
import SkillsCards from "../../components/SkillsCards/SkillsCards";
import SwiperTestimonials from "../../components/SwiperTestimonials/SwiperTestimonial";
import {useEffect} from "react";
import {useRef} from "react";
import {useTranslation} from "react-i18next";

const About: React.FC = () => {
  const {t} = useTranslation();
  const aboutmeDivRef = useRef<HTMLDivElement>(null);
  const testimonialsRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const testimonialsElement: HTMLDivElement =
      testimonialsRef.current as HTMLDivElement;

    if (aboutmeDivRef.current) {
      aboutmeDivRef.current.className = ` duration-[1s] ease-in-out`;
    }
    if (
      testimonialsElement &&
      testimonialsElement.getBoundingClientRect().top < window.innerHeight
    ) {
      testimonialsElement.className =
        "transition-opacity opacity-100 duration-[1.5s] ease-in-out";
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className=" pb-7 text-stone-300 text-start max-sm:p-6">
        <div className=" w-4/5 max-[500px]:w-full mt-0 mb-0 ml-auto mr-auto">
          <div ref={aboutmeDivRef} className=" opacity-0">
            <h2
              className=" text-lg font-medium p-0 m-0 tracking-wide
            uppercase text-gray-400 after:w-32 after:h-line-title after:inline-block after:bg-blue-400 
            after:mt-1 after:mb-1 after:ml-1 after:mr-1  "
            >
              {t("about.title")}
            </h2>
            <p className=" mt-2 mb-10 ml-0 mr-0 text-4xl font-bold uppercase text-slate-300">
              {t("about.subtitle")}
            </p>

            <div className=" flex justify-around mb-16 w-full gap-10 items-center max-md:flex-col duration-[1s] ease-in-out">
              <img
                src={profile}
                className="max-h-80 rounded-b-middle max-lg:max-h-60 "
                alt="profile_picture"
              />
              <div className="content">
                <h3 className=" font-bold text-2xl text-blue-400 mb-3">
                  {t("presentation.completeProfession")}
                </h3>
                <p className=" max-w-3xl ">
                  {t("about.description1")}
                  <br />
                  <br />
                  {t("about.description2")}
                </p>
                <div className="flex mt-3 -ml-4 gap-3 p-3">
                  <Link
                    to={"https://www.linkedin.com/in/sebastian-pitra/"}
                    target="_blank"
                    className="bg-gray-800 p-3 rounded-middle hover:bg-gray-700 transition-animationLineBefore duration-300"
                  >
                    <Linkedin color="rgb(59 130 246)" size={"20px"} />
                  </Link>
                  <Link
                    to={"https://github.com/seba-pitra"}
                    target="_blank"
                    className="bg-gray-800 p-3 rounded-middle hover:bg-gray-700 transition-animationLineBefore duration-300"
                  >
                    <Github color="rgb(59 130 246)" size={"20px"} />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <SkillsCards />

          <div ref={testimonialsRef} className="translate-y-2 opacity-0">
            <SwiperTestimonials />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
